// Liste officielle des services BESSON SOLUTIONS — source unique de vérité.
// NE PAS inventer de service additionnel ici sans validation explicite.
import { Sparkles, Target, Megaphone, Wrench, Rocket, Network, Clock } from "lucide-react";

export const SERVICES = [
  {
    id: "identite",
    icon: Sparkles,
    color: "#FFDCA8",
    n: "01",
    short: "Identité & positionnement",
    title: "Création d'identité, positionnement & naming",
    desc: "Analyse de positionnement, naming, univers de marque. On pose les fondations qui vous différencient vraiment.",
    items: ["Analyse de positionnement", "Naming", "Identité visuelle (logo, charte)", "Univers de marque & ton de voix"],
  },
  {
    id: "strategie_commerciale",
    icon: Target,
    color: "#A7F3D0",
    n: "02",
    short: "Stratégie commerciale",
    title: "Stratégie commerciale",
    desc: "On structure votre démarche commerciale : cibles, offre, pricing, pipeline, plan d'action chiffré.",
    items: ["Ciblage & segmentation", "Offre & pricing", "Plan d'action commercial", "Pipeline & KPIs"],
  },
  {
    id: "strategie_marketing",
    icon: Megaphone,
    color: "#67E8F9",
    n: "03",
    short: "Stratégie marketing",
    title: "Stratégie marketing",
    desc: "Positionnement, messages, mix-marketing, plan de contenu et déploiement multi-canal aligné sur votre stratégie commerciale.",
    items: ["Positionnement & messages", "Mix-marketing", "Plan de contenu", "Roadmap marketing"],
  },
  {
    id: "outils",
    icon: Wrench,
    color: "#06B6D4",
    n: "04",
    short: "Outils métier",
    title: "Création d'outils métier, plateforme, app",
    desc: "Nous concevons et développons les outils qui structurent votre activité : plateforme, application, dashboards, intégrations.",
    items: ["Plateforme web sur-mesure", "Application (web / mobile)", "Outils métier (CRM, ERP, dashboards)", "Intégrations & automatisations"],
  },
  {
    id: "acquisition",
    icon: Rocket,
    color: "#FFDCA8",
    n: "05",
    short: "Développement commercial",
    title: "Développement commercial",
    desc: "Génération de leads et conversion : landing pages de capture, campagnes multi-canal, SEO assisté, tracking & analytics.",
    items: ["Landing pages de capture", "Campagnes multi-canal", "SEO assisté", "Tracking & analytics"],
  },
  {
    id: "deploiement",
    icon: Network,
    color: "#A7F3D0",
    n: "06",
    short: "Licences & franchises",
    title: "Accompagnement au développement — licences & franchises",
    desc: "Structuration et accompagnement pour dupliquer votre modèle en licence ou en franchise.",
    items: ["Audit de duplicabilité", "Structuration licence / franchise", "Documentation & contrats", "Accompagnement déploiement"],
  },
  {
    id: "consulting",
    icon: Clock,
    color: "#94a3b8",
    n: "07",
    short: "Consulting à l'heure",
    title: "Consulting & conseil à l'heure",
    desc: "Besoin d'un avis stratégique ponctuel, d'un coup de main sur une décision clé ? Réservez une session conseil à l'heure.",
    items: ["Audit flash", "Conseil stratégique", "Sparring partner", "Mentoring direction"],
  },
];

export const SERVICE_IDS = SERVICES.map((s) => s.id);

// Catégories d'intervention — alignées avec le mega-menu (Header.jsx)
// Source unique : un service appartient à UNE catégorie (pas de doublon).
export const SERVICE_CATEGORIES = [
  {
    key: "preparation",
    title: "Préparation d'un projet",
    desc: "Cadrer l'idée, le positionnement et le plan d'action.",
    color: "#FFDCA8",
    service_ids: ["identite", "strategie_commerciale", "strategie_marketing", "consulting"],
  },
  {
    key: "creation",
    title: "Création d'entreprise",
    desc: "Lancer la marque et les outils qui structurent l'activité.",
    color: "#A7F3D0",
    service_ids: ["outils", "acquisition"],
  },
  {
    key: "developpement",
    title: "Développement d'entreprise",
    desc: "Scaler le modèle, dupliquer en licences ou en franchises.",
    color: "#67E8F9",
    service_ids: ["deploiement"],
  },
];

export function getServiceCategory(id) {
  return SERVICE_CATEGORIES.find((c) => c.service_ids.includes(id)) || null;
}

export function getService(id) {
  return SERVICES.find((s) => s.id === id) || null;
}

// Mapping stade entrepreneur → services pertinents (parmi les 7 ci-dessus).
// Aucun service additionnel n'est inventé : on pioche dans la liste officielle.
export const STAGE_TO_SERVICE_IDS = {
  idee: ["identite", "strategie_commerciale", "strategie_marketing", "consulting"],
  lancement: ["identite", "strategie_commerciale", "outils", "acquisition"],
  croissance: ["strategie_marketing", "outils", "acquisition", "consulting"],
  etabli: ["deploiement", "outils", "strategie_commerciale", "consulting"],
};
